import React, { useState } from "react";
import { Container, Grid, Box, Tabs, Tab, Typography } from "@mui/material";
import List from "./inc/Lists";
import AddDistrictUser from "./inc/AddDistrictUser";
import AddDistrict from "./inc/AddDistrict";
import DistrictUsers from "./inc/DistrictUsers";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminDistricts = () => {
  const [listRefresh, setListRefresh] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const pageName = "Districts";
  const icon = faBarChart;

  const handleSuccess = () => {
    setListRefresh(!listRefresh);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <AddDistrict onRefresh={handleSuccess} />
            <AddDistrictUser onSuccess={handleSuccess} />
          </Grid>
          <Grid item xs={12}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="District Tabs"
            >
              <Tab label="Districts" />
              <Tab label="District Users" />
            </Tabs>
            {tabValue === 0 && (
              <Box sx={{ padding: 2 }}>
                <List key={listRefresh.toString()} />
              </Box>
            )}
            {tabValue === 1 && (
              <Box sx={{ padding: 2 }}>
                <DistrictUsers listRefresh={listRefresh} />
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpAdminDistricts;
